export default function ImageLink(url) {
  return `${process.env.IMAGE_BASE_URL}${url}`;
}
